// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/admin/styles/AdminTherapyCategory.scss
// module id = 1406
// module chunks = 0